export default "__VITE_ASSET__b26a9695__"